import type { IApplicationState } from '../../types/redux';
import type { TSetNewAnswerFormOpenPayload } from '../../actions/newAnswer/openFormActions';

export const getIsOpen = (state: IApplicationState): TSetNewAnswerFormOpenPayload | null => {
  return state.newAnswer.meta.openId;
};
